<template>
  <div class="assess">
    <div class="assess_gb">
      <div class="nurse_top">
        <div style="height:54px;line-height:54px;">
          <img style="vertical-align:middle;" src="../../assets/beadhouse/juxing.png" />
          <span>{{ admissionManager.admissionManager }}</span>
        </div>
      </div>
      <div class="row_link clearfix">
        <div class="item" v-for="(item, index) in infoList" :key="index" @click="handleClick(item.uid)">
          <a>
            <img :src="item.img" />
            <h5 style="font-size:16px;">{{ item.title }}</h5>
            <span>{{ item.text }}</span>
          </a>
        </div>
      </div>
      <div style="margin-top:80px;margin-bottom:20px;text-align:center;">
        <img src="../../assets/beadhouse/hengang.png" alt />
      </div>

      <el-row style="margin-top:40px">
        <el-col :span="2" :offset="2" class="imgText">
          <img src="../../assets/beadhouse/ry_jiben.png" height="80" />
          <br />
          <span>基本信息录入</span>
        </el-col>
        <el-col :span="7">
          <div>
            <h4 class="circle">·····················</h4>
          </div>
        </el-col>
        <el-col :span="2" class="imgText">
          <img src="../../assets/beadhouse/ry_huli.png" height="80" />
          <br />
          <span>收费项目选择</span>
        </el-col>
        <el-col :span="7">
          <div>
            <h4 class="circle">·····················</h4>
          </div>
        </el-col>
        <el-col :span="2" class="imgText">
          <img src="../../assets/beadhouse/ry_ruzhu.png" height="80" />
          <br />
          <span>缴费信息录入</span>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
export default {
  name: "AdmissionManager",
  data() {
    return {
      admissionManager: {
        admissionManager: "入院办理",
        title_1: "取消预约",
        title_2: "入院咨询",
        title_3: "评估记录",
        title_4: "入院办理",
        title_5: "老人列表",
        title_6: "入院列表",
        title_7: "评估管理",
        text_1: "对老人预约的床位取消",
        text_2: "对有意向入住的老人进行登记",
        text_3: "对老人自理状态进行评估",
        text_4: "针对老人的基本信息身体情况进行填写",
        text_5: "老人录入信息的",
        text_6: "入院老人的数据",
        text_7: "老人评估管理",
        basicInformation: "基本信息登记",
        serviceTypeAndoneself: "服务与护理",
        admissionToChoose: "入院消费项目",
        nocycleSelection: "非周期消费项目",
        cycleSelection: "周期消费项目",
        paymentInformation: "缴费信息录入"
      }, //引入 lang 里面的字符串资源
      infoList: [] //数据源
    };
  },
  methods: {
    //点击每个
    handleClick(uid) {
      console.log(uid);
      switch (uid) {
        case 1:
          bus.$emit("homePage", {
            type: "jump",
            path: "/AdmissionCancel",
            title: this.admissionManager.title_1
          });
          break;
        case 2:
          bus.$emit("homePage", {
            type: "jump",
            path: "/AdmissionConsult",
            title: this.admissionManager.title_2
          });
          break;
        case 3:
          bus.$emit("homePage", {
            type: "jump",
            path: "/AdmissionPg",
            title: this.admissionManager.title_3
          });
          break;
        case 4:
          bus.$emit("homePage", {
            type: "jump",
            path: "/AdmissionOlderList",
            title: this.admissionManager.title_4
          });
          break;
      }
    },
    /**
     * 获取菜单栏的数据列表
     */
    getPageData() {
      this.infoList = [];
      this.infoList.push({
        url: '/AdmissionConsult',
        img: require("../../assets/beadhouse/admissionConsult.png"),
        title: this.admissionManager.title_2,
        text: this.admissionManager.text_2,
        uid: 2
      });
      this.infoList.push({
        url: '/admissionPg',
        img: require("../../assets/beadhouse/admissionPg.png"),
        title: this.admissionManager.title_3,
        text: this.admissionManager.text_3,
        uid: 3
      });
      this.infoList.push({
        url: '/AdmissionCancel',
        img: require("../../assets/beadhouse/admissionCancel.png"),
        title: this.admissionManager.title_1,
        text: this.admissionManager.text_1,
        uid: 1
      });
      this.infoList.push({
        url: '/admissionOlderList',
        img: require("../../assets/beadhouse/admissionOlderList.png"),
        title: this.admissionManager.title_4,
        text: this.admissionManager.text_4,
        uid: 4
      });
    }
  },
  created() {
    this.getPageData();
  },
  mounted() { }
};
</script>
<style scoped lang="scss">

.toolbar{
  padding-left: 8px;
  padding-top: 5px;
}
.assess {
  background: #fff;
  height: 95%;
}

.circle {
  font-size: 30px;
  color: #467fe5;
}

.imgText {
  text-align: center;
  color: #898989;
  font-size: 18px;
}

.nurse_top {
  border: 1px #f1eff2 solid;
  background: #f9f7fa;
  position: relative;
  margin-bottom: 80px;

  img {
    margin: 14px 12px;
  }

  h5 {
    display: inline-block;
    position: absolute;
    top: 12px;
    font-size: 18px;
  }
}

.row_link {
  width: 1259px;
  margin: 34px 35px;

  .item {
    width: 275px;
    height: 99px;
    border: #f0f0f2 1px solid;
    margin-bottom: 34px;
    margin-right: 34px;
    float: left;
    cursor: pointer;

    img {
      float: left;
      margin: 8px 23px 8px 33px;
      margin-right: 16px;
    }

    span {
      color: #666666;
    }

    h5 {
      margin-top: 21px;
      margin-bottom: 8px;
    }

    a:hover {
      color: #333;
    }
  }

  .item:hover {
    border: 1px solid red;
  }
}</style>
